module.exports = __webpack_public_path__ + "img/border.4436dcf0.png";